<template>
  <div class="mail">
    <nav class="robbing-nav">
      <div class="robbing-nav-item select">预约寄件</div>
      <div class="robbing-nav-item" @click="gotoYunfei">收费标准</div>
    </nav>
    <div class="empty-data" v-if="userInfo.worksite && !userInfo.worksite.jijianAble">
      <div>
        <i class="iconfont icon-similarproduct"></i>
      </div>
      <div>
        <p style="font-size: 18px;color: red; font-weight: bold;">寄件功能暂未开通</p>
        <p style="font-size: 12px;">具体开通时间请留意快递服务中心通知</p>
      </div>
    </div>
    <div class="mail-get" v-if="userInfo.worksite && userInfo.worksite.jijianAble">
      <section class="mail-tips">
        <span style="font-size:14px; font-weight: bold;">寄件须知</span>
        <p style="font-size:12px;">
          请如实填写寄件电子单，如需上门取件，请仔细阅读并自觉遵守
          <a
            href="javascript:;"
            style="color: blue; text-decoration:underline;"
            @click="agreement"
          >《校圆通跑腿协议》</a> 。
        </p>
      </section>
      <div class="weui-cells" v-show="!isAddingAddress">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="chooseExpress">
          <div class="weui-cell__bd">
            <p>快递公司</p>
          </div>
          <div
            class="weui-cell__ft"
          >{{currExpressSendCompany.name?currExpressSendCompany.name:'请选择'}}</div>
        </a>
      </div>
      <section class="mail-toandget" v-show="!isAddingAddress">
        <div class="mail-to mail-item">
          <div class="mail-item-left">
            <span class="iconfont icon-ji jijian"></span>
          </div>
          <div class="mail-item-middle mail-item-middle_jijian">
            <div>
              <div v-if="jijianAddress.name && !isChoosingJijian">
                <p>
                  <span class="mail-user">{{jijianAddress.name}}</span>
                  <span>{{jijianAddress.phone}}</span>
                </p>
                <p>{{jijianAddress.province.name}}{{jijianAddress.city.name}}{{jijianAddress.county.name}}{{jijianAddress.detail}}</p>
              </div>
              <div class="mail-item_empty" v-if="!jijianAddress.name && !isChoosingJijian">
                <p>请选择寄件人</p>
              </div>
            </div>
            <div class="weui-cells weui-cells_radio" v-show="isChoosingJijian">
              <label
                class="weui-cell weui-check__label to-choose-item"
                :for="'jijian'+item._id"
                v-for="item in addresses"
                :key="item._id"
              >
                <div class="weui-cell__bd">
                  <p>{{item.name}} {{item.phone}}</p>
                  <p
                    class="weui-cell_address"
                  >{{item.province.name}}{{item.city.name}}{{item.county.name}}{{item.detail}}</p>
                </div>
                <div class="weui-cell__ft">
                  <input
                    type="radio"
                    class="weui-check"
                    name="jijian_radio"
                    :ref="'jijian'+item._id"
                    :id="'jijian'+item._id"
                    @click="chooseJijian(item)"
                  />
                  <span class="weui-icon-checked"></span>
                </div>
              </label>
              <a href="javascript:void(0);" class="weui-cell weui-cell_link">
                <div class="weui-cell__bd">
                  <span class="add-address" @click="addMoreAddress(1)">添加新地址</span>
                  <span class="edit-address">管理地址</span>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="mail-get mail-item">
          <div class="mail-item-left">
            <span class="iconfont icon-shou shoujian"></span>
          </div>
          <div class="mail-item-middle mail-item-middle_shoujian">
            <div @click="toggleShoujianChoosing">
              <div v-if="shoujianAddress.name && !isChoosingShoujian">
                <p>
                  <span class="mail-user">{{shoujianAddress.name}}</span>
                  <span>{{shoujianAddress.phone}}</span>
                </p>
                <p>{{shoujianAddress.province.name}}{{shoujianAddress.city.name}}{{shoujianAddress.county.name}}{{shoujianAddress.detail}}</p>
              </div>
              <div class="mail-item_empty" v-if="!shoujianAddress.name && !isChoosingShoujian">
                <p>请选择收件人</p>
              </div>
            </div>
            <div class="weui-cells weui-cells_radio" v-show="isChoosingShoujian">
              <label
                class="weui-cell weui-check__label to-choose-item"
                :for="'shoujian'+item._id"
                v-for="item in shoujianAddresses"
                :key="item._id"
              >
                <div class="weui-cell__bd">
                  <p>{{item.name}} {{item.phone}}</p>
                  <p
                    class="weui-cell_address"
                  >{{item.province.name}}{{item.city.name}}{{item.county.name}}{{item.detail}}</p>
                </div>
                <div class="weui-cell__ft">
                  <input
                    type="radio"
                    class="weui-check"
                    name="shoujian_radio"
                    :ref="'shoujian'+item._id"
                    :id="'shoujian'+item._id"
                    @click="chooseShoujian(item)"
                  />
                  <span class="weui-icon-checked"></span>
                </div>
              </label>
              <a href="javascript:void(0);" class="weui-cell weui-cell_link">
                <div class="weui-cell__bd">
                  <span class="add-address" @click="addMoreAddress(2)">添加新地址</span>
                  <span class="edit-address" @click="managerAddress">管理地址</span>
                </div>
              </a>
            </div>
          </div>
          <div class="mail-item-right" @click="toggleShoujianChoosing">
            <i class="iconfont icon-xiangyoujiantou" aria-hidden="true"></i>
          </div>
        </div>
      </section>

      <div class="weui-cells weui-cells_form address" v-if="isAddingAddress">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label">联系人员</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              placeholder="请输入收件联系人姓名"
              v-model="addAddress.name"
              style="text-align: right;"
            />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label">联系电话</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="addAddress.phone"
              oninput="if(value.length>11)value=value.slice(0,11)"
              placeholder="请输入收件联系人联系电话"
              style="text-align: right;"
            />
          </div>
        </div>
        <div class="weui-cells" @click="showAsyncPicker">
          <a class="weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
              <p>省市区</p>
            </div>
            <div
              class="weui-cell__ft"
            >{{addAddress.province&&addAddress.city&&addAddress.county?addAddress.provinceName.substr(0, 3)+'-'+addAddress.cityName.substr(0, 3)+'-'+addAddress.countyName.substr(0, 3):'请选择'}}</div>
          </a>
        </div>
        <div class="weui-cell" style="border-bottom: 1px solid #eee;">
          <div class="weui-cell__hd">
            <label class="weui-label">详细地址</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" placeholder="请输入详细地址" v-model="addAddress.detail" />
          </div>
        </div>
        <div class="addressAddBtn">
          <a
            href="javascript:;"
            class="weui-btn weui-btn_mini weui-btn_warn"
            style="margin-right: 10px; background-color: #0062B6;"
            @click="cancelAdding"
          >返 回</a>
          <a
            href="javascript:;"
            class="weui-btn weui-btn_mini weui-btn_primary"
            @click="saveAdding"
          >确 定</a>
        </div>

        <div class="weui-cells__title" style="color: red;">::您也可以粘贴整段地址，自动识别收件信息::</div>
        <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                v-model="autoAddress"
                placeholder="姓名、电话和姓名用逗号或空格分割"
                rows="3"
              ></textarea>
              <div class="weui-textarea-counter">
                <span>0</span>/80
              </div>
            </div>
          </div>
        </div>
        <div class="addressAddBtn">
          <a
            href="javascript:;"
            class="weui-btn weui-btn_mini weui-btn_warn"
            style="margin-right: 10px;"
            @click="clearAutoAddress"
          >清 空</a>
          <a
            href="javascript:;"
            class="weui-btn weui-btn_mini weui-btn_primary"
            @click="regAutoAddress"
          >识 别</a>
        </div>
      </div>

      <section class="mail-setmsg" v-show="!isAddingAddress">
        <div class="weui-cells weui-cells_form" style="margin-top: -1px;">
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label class="weui-label">
                物品名称
                <span style="color: red;">*</span>
              </label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                v-model="goodsName"
                maxlength="12"
                oninput="if(value.length>12)value=value.slice(0,12)"
                placeholder="待寄物品名称"
                style="text-align: right;"
              />
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label class="weui-label">
                物品数量
                <span style="color: red;">*</span>
              </label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                v-model="goodsCount"
                type="number"
                placeholder="待寄物品数量"
                style="text-align: right;"
              />
            </div>
          </div>
          <div class="weui-cell weui-cell_switch" v-if="showDaofu">
            <div class="weui-cell__bd">运费到付</div>
            <div class="weui-cell__ft">
              <label for="switchDaofu" class="weui-switch-cp">
                <input
                  id="switchDaofu"
                  class="weui-switch-cp__input"
                  type="checkbox"
                  v-model="isDaofu"
                />
                <div class="weui-switch-cp__box"></div>
              </label>
            </div>
          </div>
          <div
            class="weui-cell weui-cell_switch"
            v-if="userInfo.worksite && userInfo.worksite.paotuiAble"
          >
            <div class="weui-cell__bd">
              上门取件
              <span style="color: red; font-size: 12px;">（发布一个跑腿任务）</span>
            </div>
            <div class="weui-cell__ft">
              <label for="switchCP" class="weui-switch-cp">
                <input
                  id="switchCP"
                  class="weui-switch-cp__input"
                  type="checkbox"
                  v-model="requiredDoorService"
                />
                <div class="weui-switch-cp__box"></div>
              </label>
            </div>
          </div>
        </div>
        <div
          class="weui-cells__title"
          style="color: red; font-weight: bold;"
          v-if="requiredDoorService"
        >
          <i class="iconfont icon-warning" style="font-weight: bold;"></i>
          上门时间:{{expressNoonDoorServiceBegin}}-{{expressNoonDoorServiceEnd}} 或 {{expressPmDoorServiceBegin}}-{{expressPmDoorServiceEnd}}
        </div>
        <div
          class="weui-cells weui-cells_form"
          style="margin-top: -1px;"
          v-if="requiredDoorService"
        >
          <a class="weui-cell weui-cell_access" href="javascript:;" @click="showBuildingPicker">
            <div class="weui-cell__bd">
              <p>所在大楼</p>
            </div>
            <div class="weui-cell__ft">{{pickBuildingTxt?pickBuildingTxt:"请选择"}}</div>
          </a>
          <a
            class="weui-cell weui-cell_access"
            href="javascript:;"
            @click="showFloorPicker"
            v-if="requiredDoorService"
          >
            <div class="weui-cell__bd">
              <p>所在楼层</p>
            </div>
            <div class="weui-cell__ft">{{pickFloor?pickFloor+"楼":"请选择"}}</div>
          </a>
          <div class="weui-cell" v-if="requiredDoorService">
            <div class="weui-cell__hd">
              <label class="weui-label">宿舍号码</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                v-model="dormRoom"
                placeholder="请输入宿舍号码"
                style="text-align: right;"
              />
            </div>
          </div>
        </div>
        <div class="weui-cells__title" v-if="requiredDoorService">
          请选择您的物品类别
          <span class="need">*</span>
        </div>
        <div class="weui-cells weui-cells_checkbox" v-if="requiredDoorService">
          <label class="weui-cell weui-check__label" for="s11">
            <div class="weui-cell__hd">
              <input
                type="radio"
                class="weui-check"
                name="goodsType"
                id="s11"
                @change="chooseGoodsType(1)"
              />
              <i class="weui-icon-checked"></i>
            </div>
            <div class="weui-cell__bd">
              <p>小件物品（&lt;0.5kg）</p>
            </div>
          </label>
          <label class="weui-cell weui-check__label" for="s12">
            <div class="weui-cell__hd">
              <input
                type="radio"
                name="goodsType"
                class="weui-check"
                id="s12"
                @change="chooseGoodsType(2)"
              />
              <i class="weui-icon-checked"></i>
            </div>
            <div class="weui-cell__bd">
              <p>中件物品（0.5kg ~ 2kg）</p>
            </div>
          </label>
          <label class="weui-cell weui-check__label" for="s13">
            <div class="weui-cell__hd">
              <input
                type="radio"
                name="goodsType"
                class="weui-check"
                id="s13"
                @change="chooseGoodsType(3)"
              />
              <i class="weui-icon-checked"></i>
            </div>
            <div class="weui-cell__bd">
              <p>大件物品（&gt;2kg）</p>
            </div>
          </label>
        </div>
        <div class="weui-cells__title" v-if="requiredDoorService && goodsType==3">
          大件分类
          <span class="need">*</span>
        </div>
        <div class="weui-cells weui-cells_checkbox" v-if="requiredDoorService && goodsType==3">
          <label
            class="weui-cell weui-check__label"
            :for="item._id"
            v-for="(item, index) in specialGoods"
            :key="index"
          >
            <div class="weui-cell__hd">
              <input
                type="radio"
                class="weui-check"
                name="goodsDetail"
                :id="item._id"
                @change="chooseGoodsDetail(item)"
              />
              <i class="weui-icon-checked"></i>
            </div>
            <div class="weui-cell__bd">
              <p>{{item.name}}</p>
            </div>
          </label>
        </div>
        <div class="weui-cells__title" v-if="requiredDoorService">上门收件备注</div>
        <div class="weui-cells weui-cells_checkbox" v-if="requiredDoorService">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                v-model="paotuiRemark"
                placeholder="请输入上门收件备注（选填）"
                rows="1"
              ></textarea>
              <div class="weui-textarea-counter" :class="{'address-error':paotuiRemark.length>20}">
                <span>{{paotuiRemark.length}}</span>/20
              </div>
            </div>
          </div>
        </div>
        <div class="weui-cells__title">寄件备注</div>
        <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <textarea class="weui-textarea" placeholder="请输入您的寄件备注" v-model="remark" rows="1"></textarea>
              <div class="weui-textarea-counter" :class="{'remark-error':remark.length>20}">
                <span>{{remark.length}}</span>/20
              </div>
            </div>
          </div>
        </div>
      </section>
      <a
        href="javascript:;"
        class="mail-submit"
        @click="addTotakein"
        v-show="!isAddingAddress"
        v-if="!isAddingAddress && !requiredDoorService"
      >预约寄件</a>
      <div style="display: flex;" v-if="requiredDoorService">
        <div class="warehousing-footer-item shangjin" style="flex: 2">￥{{fee}}元</div>
        <div class="warehousing-footer-item" style="flex:3" @click="addTotakein">
          <a href="javascript:;">预约寄件</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
import commonUtil from "../utils/commonUtil.js";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      userInfo: {},
      worksite: {},
      worksiteId: "",
      schoolCode: "",
      currExpressSendCompany: {},
      expressSendCompanies: [],
      escPicker: [
        {
          label: "请选择",
          value: ""
        }
      ],
      showDaofu: false,
      isDaofu: false,
      isAddingAddress: false,
      currAddingType: 0,
      asyncSelectedIndex: [0, 0, 0],
      ssqItems: [
        {
          _id: -1,
          text: "请选择",
          value: -1,
          children: [
            {
              _id: -1,
              text: "请选择",
              value: -1,
              children: [
                {
                  _id: -1,
                  text: "请选择",
                  value: -1
                }
              ]
            }
          ]
        }
      ],
      addresses: [],
      shoujianAddresses: [],
      jijianAddress: {},
      isChoosingJijian: false,
      shoujianAddress: {},
      isChoosingShoujian: false,
      goodsName: "",
      goodsCount: 1,
      estimateWeight: "",
      insureMoney: "", // 保价
      wfPicker: [],
      requiredDoorService: false,
      dormBuilding: this.pickBuildingId,
      dormFloor: this.pickFloor,
      dormRoom: this.dormRoom,
      buildingPicker: null,
      buildings: [],
      floorPicker: null,
      floors: [],
      pickBuildingId: null,
      pickBuildingTxt: null,
      pickBuildingAreaTxt: null,
      pickFloor: null,
      specialGoods: [], // 如果选择的大楼定义有特殊大件，则使用该大楼自定义的，否则使用全局的
      goodsType: null,
      goodsDetail: null,
      liftSmallFee: null,
      liftMiddleFee: null,
      liftBigFee: null,
      smallFeeOne: null,
      smallFeeTwo: null,
      middleFeeOne: null,
      middleFeeTwo: null,
      bigFeeOne: null,
      bigFeeTwo: null,
      expressNoonDoorServiceBegin: "12:00",
      expressNoonDoorServiceEnd: "14:00",
      expressPmDoorServiceBegin: "19:00",
      expressPmDoorServiceEnd: "23:00",
      doorServiceData: [],
      sexLimit: {
        value: -1,
        label: "不限"
      },
      fee: 0,
      paotuiRemark: "",
      remark: "",
      addAddress: {
        name: "",
        phone: "",
        province: "",
        city: "",
        county: "",
        provinceName: "",
        cityName: "",
        countyName: "",
        detail: ""
      },
      provinces: [],
      autoAddress: ""
    };
  },
  created() {
    let that = this;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    // 获取用户常用地址列表
    axios
      .get("/api/address/wxlist")
      .then(response => {
        this.addresses = response.data.data;
        for (let i = 0; i < this.addresses.length; i++) {
          if (this.addresses[i].isDefault) {
            this.jijianAddress = this.addresses[i];
          } else {
            this.shoujianAddresses.push(this.addresses[i]);
          }
        }
      })
      .catch(error => {
        weui.topTips("获取重量费用类型列表失败", 2000);
      });

    // 获取省市列表
    axios
      .get("/api/province/list")
      .then(response => {
        this.provinces = response.data.data;
        for (let i = 0; i < this.provinces.length; i++) {
          let ssqItem = {
            value: this.provinces[i]._id,
            text: this.provinces[i].name,
            code: this.provinces[i].code,
            children: [
              {
                text: "请选择",
                value: -1,
                children: [
                  {
                    text: "请选择",
                    value: -1
                  }
                ]
              }
            ]
          };
          this.ssqItems.push(ssqItem);
        }
      })
      .catch(error => {
        weui.topTips("获取省列表失败", 2000);
      });

    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        this.userInfo = response.data.data;

        if (this.userInfo.authStatus == -1) {
          this.$createDialog({
            type: "alert",
            title: "温馨提醒",
            content: "国家邮管局规定寄件必须实名，请点确定去实名认证。",
            icon: "cubeic-alert",
            onConfirm: () => {
              this.$router.push(
                "/authApply/0/expressTotakein/" + this.encodeToken
              );
            }
          }).show();
        }

        this.worksite = response.data.data.worksite;
        this.worksiteId = response.data.data.worksite._id;
        this.schoolCode = response.data.data.worksite.schoolCode;

        this.specialGoods = this.worksite.specialGoods;
        this.specialGoods.push({
          _id: -1,
          name: "其他",
          liftFee: this.worksite.liftBigFee,
          feeOne: this.worksite.bigFeeOne,
          feeTwo: this.worksite.bigFeeTwo
        });

        this.expressNoonDoorServiceBegin = this.worksite.expressNoonDoorServiceBegin;
        this.expressNoonDoorServiceEnd = this.worksite.expressNoonDoorServiceEnd;
        this.expressPmDoorServiceBegin = this.worksite.expressPmDoorServiceBegin;
        this.expressPmDoorServiceEnd = this.worksite.expressPmDoorServiceEnd;

        let buildingInfo = this.userInfo.dormBuilding;
        let feeIsInited = false;
        if (buildingInfo) {
          this.pickBuildingId = buildingInfo._id;

          if (buildingInfo.area) {
            axios
              .get("/api/area/getById/" + buildingInfo.area)
              .then(res => {
                if (res.data.success) {
                  this.pickBuildingAreaTxt = res.data.data.name;
                  this.pickBuildingTxt =
                    res.data.data.name +
                    "-" +
                    buildingInfo.name +
                    "(" +
                    buildingInfo.tag +
                    ")";
                } else {
                  this.pickBuildingTxt =
                    buildingInfo.name + "(" + buildingInfo.tag + ")";
                }
              })
              .catch(err => {
                console.log(err);
                this.pickBuildingTxt =
                  buildingInfo.name + "(" + buildingInfo.tag + ")";
              });
          } else {
            this.pickBuildingTxt =
              buildingInfo.name + "(" + buildingInfo.tag + ")";
          }
          this.isLift = buildingInfo.isLift;

          if (buildingInfo.liftSmallFee || buildingInfo.smallFeeOne) {
            this.liftSmallFee = buildingInfo.liftSmallFee;
            this.liftMiddleFee = buildingInfo.liftMiddleFee;
            this.liftBigFee = buildingInfo.liftBigFee;
            this.smallFeeOne = buildingInfo.smallFeeOne;
            this.smallFeeTwo = buildingInfo.smallFeeTwo;
            this.middleFeeOne = buildingInfo.middleFeeOne;
            this.middleFeeTwo = buildingInfo.middleFeeTwo;
            this.bigFeeOne = buildingInfo.bigFeeOne;
            this.bigFeeTwo = buildingInfo.bigFeeTwo;
            this.specialGoods = buildingInfo.specialGoods;
            this.specialGoods.push({
              _id: -1,
              name: "其他",
              liftFee: buildingInfo.liftBigFee,
              feeOne: buildingInfo.bigFeeOne,
              feeTwo: buildingInfo.bigFeeTwo
            });
            feeIsInited = true;
          }
        }

        this.pickFloor = this.userInfo.dormFloor;
        this.dormRoom = this.userInfo.dormRoom;

        // 获取大楼列表
        axios
          .get("/api/building/list/" + this.worksiteId)
          .then(res => {
            if (res.data.success) {
              let list = res.data.data;
              for (let i = 0; i < list.length; i++) {
                let item = list[i];
                if (item.area) {
                  item.name = item.area.name + "-" + item.name;
                }
                if (item.tag) {
                  item.alias = item.name + "(" + item.tag + ")";
                } else {
                  item.alias = item.name;
                }
                this.buildings.push({
                  text: item.alias,
                  value: item._id,
                  isLift: item.isLift,
                  item: item
                });
              }
            } else {
              weui.alert("获取大楼列表失败");
            }
          })
          .catch(err => {
            weui.alert("获取大楼列表失败");
          });

        // 根据worksiteId 获取当前可用的寄件快递列表
        axios
          .get("/api/worksite/detail/" + that.worksiteId)
          .then(res => {
            this.expressSendCompanies = res.data.data.expressSendCompanies;
            for (let i = 0; i < this.expressSendCompanies.length; i++) {
              let item = {
                label: this.expressSendCompanies[i].name,
                value: this.expressSendCompanies[i]._id
              };
              this.escPicker.push(item);
            }

            if (!feeIsInited) {
              this.liftSmallFee = res.data.data.liftSmallFee;
              this.liftMiddleFee = res.data.data.liftMiddleFee;
              this.liftBigFee = res.data.data.liftBigFee;
              this.smallFeeOne = res.data.data.smallFeeOne;
              this.smallFeeTwo = res.data.data.smallFeeTwo;
              this.middleFeeOne = res.data.data.middleFeeOne;
              this.middleFeeTwo = res.data.data.middleFeeTwo;
              this.bigFeeOne = res.data.data.bigFeeOne;
              this.bigFeeTwo = res.data.data.bigFeeTwo;
            }
          })
          .catch(err => {
            weui.topTips("获取可用寄件快递列表失败", 2000);
          });
      })
      .catch(error => {
        weui.topTips("获取用户信息失败", 2000);
      });

    /**
     * 送件上门取件时间选择数据：
     * 早上9点之后晚上11点之前
     * 如果当前时间已经超过晚上10点，则只能选择明天、后天、大后天的时间
     * 如果当前时间还未超过晚上10点，能选今天9点之后并在当前时间点之后到晚上11点的时间，明天、后天的时间
     */
    let nowTime30MinLaterLong = moment()
      .add(30, "m")
      .unix();
    let todayFirstTimeLong = moment(
      moment().format("YYYY-MM-DD") + " 09:00:00"
    ).unix();
    let todayLastTimeLong = moment(
      moment().format("YYYY-MM-DD") + " 23:00:00"
    ).unix();
    let normalM = [
      { value: "00", text: "00分" },
      { value: "10", text: "10分" },
      { value: "20", text: "20分" },
      { value: "30", text: "30分" },
      { value: "40", text: "40分" },
      { value: "50", text: "50分" }
    ];
    let normalH = [
      { value: "09", text: "9点", children: normalM },
      { value: "10", text: "10点", children: normalM },
      { value: "11", text: "11点", children: normalM },
      { value: "12", text: "12点", children: normalM },
      { value: "13", text: "13点", children: normalM },
      { value: "14", text: "14点", children: normalM },
      { value: "15", text: "15点", children: normalM },
      { value: "16", text: "16点", children: normalM },
      { value: "17", text: "17点", children: normalM },
      { value: "18", text: "18点", children: normalM },
      { value: "19", text: "19点", children: normalM },
      { value: "20", text: "20点", children: normalM },
      { value: "21", text: "21点", children: normalM },
      { value: "22", text: "22点", children: normalM }
    ];
    if (nowTime30MinLaterLong >= todayLastTimeLong) {
      // 只能选择明天、后天、大后天的时间
      let nowAdd1DayStr = moment()
        .add(1, "days")
        .format("YYYY-MM-DD");
      let nowAdd2DayStr = moment()
        .add(2, "days")
        .format("YYYY-MM-DD");
      let nowAdd3DayStr = moment()
        .add(3, "days")
        .format("YYYY-MM-DD");
      this.doorServiceData = [
        {
          value: nowAdd1DayStr,
          text: "明天",
          children: normalH
        },
        {
          value: nowAdd2DayStr,
          text: "后天",
          children: normalH
        },
        {
          value: nowAdd3DayStr,
          text: "大后天",
          children: normalH
        }
      ];
    } else {
      // 可选今天9点之后并在当前时间点之后到晚上11点的时间，明天、后天的时间
      let nowAdd0DayStr = moment().format("YYYY-MM-DD");
      let nowAdd1DayStr = moment()
        .add(1, "days")
        .format("YYYY-MM-DD");
      let nowAdd2DayStr = moment()
        .add(2, "days")
        .format("YYYY-MM-DD");

      let nowDayChoose = {
        value: nowAdd0DayStr,
        text: "今天"
      };

      let nowHour = moment().format("H");
      let serviceAbleHour = moment()
        .add(30, "m")
        .format("H");
      let serviceAbleMin = moment()
        .add(30, "m")
        .format("m");
      if (serviceAbleHour < 9) {
        nowDayChoose.children = normalH;
      } else {
        let hArray = [];
        let index = 0;
        for (let i = serviceAbleHour; i < 23; i++) {
          let serviceAbleHourStr = i;
          if (i < 10) {
            serviceAbleHourStr = "0" + i;
          }

          let firstMinArray = [];
          if (serviceAbleMin < 10) {
            firstMinArray = [
              { value: "10", text: "10分" },
              { value: "20", text: "20分" },
              { value: "30", text: "30分" },
              { value: "40", text: "40分" },
              { value: "50", text: "50分" }
            ];
          } else if (serviceAbleMin < 20) {
            firstMinArray = [
              { value: "20", text: "20分" },
              { value: "30", text: "30分" },
              { value: "40", text: "40分" },
              { value: "50", text: "50分" }
            ];
          } else if (serviceAbleMin < 30) {
            firstMinArray = [
              { value: "30", text: "30分" },
              { value: "40", text: "40分" },
              { value: "50", text: "50分" }
            ];
          } else if (serviceAbleMin < 40) {
            firstMinArray = [
              { value: "40", text: "40分" },
              { value: "50", text: "50分" }
            ];
          } else if (serviceAbleMin < 50) {
            firstMinArray = [{ value: "50", text: "50分" }];
          }

          let h = {
            value: serviceAbleHourStr,
            text: i + "点"
          };
          if (index == 0 && serviceAbleMin < 50) {
            h.children = firstMinArray;
            hArray.push(h);
          } else if (index > 0) {
            h.children = normalM;
            hArray.push(h);
          }
          index++;
        }
        nowDayChoose.children = hArray;
      }
      this.doorServiceData = [
        nowDayChoose,
        {
          value: nowAdd1DayStr,
          text: "明天",
          children: normalH
        },
        {
          value: nowAdd2DayStr,
          text: "后天",
          children: normalH
        }
      ];
    }
  },
  mounted() {
    this.asyncPicker = this.$createCascadePicker({
      title: "省市区",
      async: true,
      data: this.ssqItems,
      selectedIndex: this.asyncSelectedIndex.slice(),
      onSelect: this.selectHandle,
      onCancel: this.cancelHandle,
      onChange: this.asyncChangeHandle
    });

    // 上门时间选择
    this.doorServicePicker = this.$createCascadePicker({
      title: "上门取件时间",
      data: this.doorServiceData,
      selectedIndex: [0, 1, 0],
      onSelect: this.doorServiceSelectHandle,
      onCancel: this.doorServiceCancelHandle
    });
  },
  methods: {
    gotoYunfei() {
      this.$router.push({
        name: "Yunfei",
        params: {
          token: this.encodeToken,
          pic: this.worksite.yunfeiPic
        }
      });
    },
    agreement() {
      this.$router.push("/paotuiAgreement");
    },
    chooseGoodsType(goodsType) {
      // 先选择大楼和楼层
      if (!this.pickBuildingId) {
        document.getElementById("s1" + goodsType).checked = false;
        weui.alert("请选择大楼");
        return;
      } else if (!this.pickFloor) {
        document.getElementById("s1" + goodsType).checked = false;
        weui.alert("请选择楼层");
        return;
      } else {
        this.goodsType = goodsType;
        if (goodsType != 3) {
          this.goodsDetail = null;
        }
        this.calculate();
      }
    },
    chooseGoodsDetail(item) {
      this.goodsDetail = item;
      this.calculate();
    },
    calculate() {
      this.fee = 0;
      if (this.goodsType && this.pickBuildingId) {
        if (this.goodsType == 1) {
          if (this.isLift) {
            this.fee = this.liftSmallFee;
          } else {
            if (this.pickFloor && this.pickFloor < 4) {
              this.fee = this.smallFeeOne;
            } else if (this.pickFloor) {
              this.fee = this.smallFeeTwo;
            }
          }
        } else if (this.goodsType == 2) {
          if (this.isLift) {
            this.fee = this.liftMiddleFee;
          } else {
            if (this.pickFloor && this.pickFloor < 4) {
              this.fee = this.middleFeeOne;
            } else if (this.pickFloor) {
              this.fee = this.middleFeeTwo;
            }
          }
        } else if (
          this.goodsType == 3 &&
          this.goodsDetail &&
          this.goodsDetail._id
        ) {
          if (this.isLift) {
            this.fee = this.goodsDetail.liftFee;
          } else {
            if (this.pickFloor && this.pickFloor < 4) {
              this.fee = this.goodsDetail.feeOne;
            } else {
              this.fee = this.goodsDetail.feeTwo;
            }
          }
        }
      }
    },
    showBuildingPicker() {
      if (!this.buildingPicker) {
        this.buildingPicker = this.$createPicker({
          title: "楼层选择",
          data: [this.buildings],
          onSelect: this.selectBuildingHandle
        });
      }
      this.buildingPicker.show();
    },
    selectBuildingHandle(selectedVal, selectedIndex, selectedText) {
      if (
        this.buildings[selectedIndex].item.liftSmallFee ||
        this.buildings[selectedIndex].item.smallFeeOne
      ) {
        this.liftSmallFee = this.buildings[selectedIndex].item.liftSmallFee;
        this.liftMiddleFee = this.buildings[selectedIndex].item.liftMiddleFee;
        this.liftBigFee = this.buildings[selectedIndex].item.liftBigFee;
        this.smallFeeOne = this.buildings[selectedIndex].item.smallFeeOne;
        this.smallFeeTwo = this.buildings[selectedIndex].item.smallFeeTwo;
        this.middleFeeOne = this.buildings[selectedIndex].item.middleFeeOne;
        this.middleFeeTwo = this.buildings[selectedIndex].item.middleFeeTwo;
        this.bigFeeOne = this.buildings[selectedIndex].item.bigFeeOne;
        this.bigFeeTwo = this.buildings[selectedIndex].item.bigFeeTwo;
        this.specialGoods = this.buildings[selectedIndex].item.specialGoods;
        this.specialGoods.push({
          _id: -1,
          name: "其他",
          liftFee: this.buildings[selectedIndex].item.liftBigFee,
          feeOne: this.buildings[selectedIndex].item.bigFeeOne,
          feeTwo: this.buildings[selectedIndex].item.bigFeeTwo
        });
      } else {
        this.liftSmallFee = this.worksite.liftSmallFee;
        this.liftMiddleFee = this.worksite.liftMiddleFee;
        this.liftBigFee = this.worksite.liftBigFee;
        this.smallFeeOne = this.worksite.smallFeeOne;
        this.smallFeeTwo = this.worksite.smallFeeTwo;
        this.middleFeeOne = this.worksite.middleFeeOne;
        this.middleFeeTwo = this.worksite.middleFeeTwo;
        this.bigFeeOne = this.worksite.bigFeeOne;
        this.bigFeeTwo = this.worksite.bigFeeTwo;
        // 更新其他选项费用信息
        this.specialGoods = this.worksite.specialGoods;
        this.specialGoods.push({
          _id: -1,
          name: "其他",
          liftFee: this.worksite.liftBigFee,
          feeOne: this.worksite.bigFeeOne,
          feeTwo: this.worksite.bigFeeTwo
        });
      }
      this.pickBuildingId = selectedVal;
      this.pickBuildingTxt = selectedText[0];
      this.isLift = this.buildings[selectedIndex].isLift;
      this.calculate();
    },
    showFloorPicker() {
      if (!this.floorPicker) {
        for (let i = -1; i < 31; i++) {
          if (i == 0) {
            continue;
          } else {
            this.floors.push({
              text: i + "楼",
              value: i
            });
          }
        }
        this.floorPicker = this.$createPicker({
          title: "楼层选择",
          data: [this.floors],
          onSelect: this.selectFloorHandle
        });
      }
      this.floorPicker.show();
    },
    selectFloorHandle(selectedVal, selectedIndex, selectedText) {
      this.pickFloor = selectedVal[0];
      this.calculate();
    },
    showAsyncPicker() {
      this.asyncPicker.show();
    },
    asyncChangeHandle(i, newIndex) {
      if (newIndex !== this.asyncSelectedIndex[i]) {
        this.asyncSelectedIndex[i] = newIndex;
        // If the first two column is changed, request the data for rest columns.
        let currCities = this.ssqItems[newIndex].children;
        if (i == 0) {
          if (currCities.length == 1) {
            // 加载市数据
            let params = {
              provinceCode: this.ssqItems[newIndex].code
            };
            axios
              .get("/api/city/list", { params })
              .then(res => {
                let cities = res.data.data;
                for (let i = 0; i < cities.length; i++) {
                  let ssqItem = {
                    value: cities[i]._id,
                    text: cities[i].name,
                    code: cities[i].code,
                    children: [
                      {
                        _id: -1,
                        text: "请选择",
                        value: -1
                      }
                    ]
                  };
                  this.ssqItems[newIndex].children.push(ssqItem);
                }
                this.asyncSelectedIndex[1] = 0;
                this.asyncSelectedIndex[2] = 0;
                this.asyncPicker.setData(
                  this.ssqItems,
                  this.asyncSelectedIndex
                );
              })
              .catch(err => {
                console.log(err);
              });
          } else {
            this.asyncSelectedIndex[1] = 0;
            this.asyncSelectedIndex[2] = 0;
            this.asyncPicker.setData(this.ssqItems, this.asyncSelectedIndex);
          }
        } else if (i == 1) {
          let currProv = this.ssqItems[this.asyncSelectedIndex[0]];
          let currCities = currProv.children;
          let currCounties = currCities[newIndex].children;
          if (currCounties.length == 1) {
            let params = {
              cityCode: currCities[newIndex].code
            };
            axios
              .get("/api/county/list", { params })
              .then(res => {
                let counties = res.data.data;
                for (let i = 0; i < counties.length; i++) {
                  let ssqItem = {
                    value: counties[i]._id,
                    text: counties[i].name,
                    code: counties[i].code
                  };
                  currCities[newIndex].children.push(ssqItem);
                }
                this.asyncSelectedIndex[2] = 0;
                this.asyncPicker.setData(
                  this.ssqItems,
                  this.asyncSelectedIndex
                );
              })
              .catch(err => {
                console.log(err);
              });
          } else {
            this.asyncPicker.setData(this.ssqItems, this.asyncSelectedIndex);
          }
        }
      }
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      this.addAddress.province = selectedVal[0];
      this.addAddress.city = selectedVal[1];
      this.addAddress.county = selectedVal[2];
      this.addAddress.provinceName = selectedText[0];
      this.addAddress.cityName = selectedText[1];
      this.addAddress.countyName = selectedText[2];
    },
    cancelHandle() {},
    selectTimeFn() {
      this.$refs.selectTime.click();
    },
    chooseExpress() {
      let that = this;
      weui.picker(this.escPicker, {
        className: "custom-classname",
        container: "body",
        defaultValue: [""],
        onChange: function(result) {},
        onConfirm: function(result) {
          that.currExpressSendCompany = {
            _id: result[0].value,
            name: result[0].label
          };
          /* if(that.currExpressSendCompany.name == "顺丰速运") {// 显示到付按钮
            that.showDaofu = true;
          }else {
            that.showDaofu = false;
            that.isDaofu = false;
          } */
        },
        id: "expressSendCompanyPicker"
      });
    },
    toggleJijianChoosing() {
      this.isChoosingJijian = !this.isChoosingJijian;
      if (this.jijianAddress._id) {
        let curr = "jijian" + this.jijianAddress._id;
        this.$refs[curr][0].checked = true;
      }
    },
    chooseJijian(address) {
      this.isChoosingJijian = !this.isChoosingJijian;
      this.jijianAddress = address;
    },
    toggleShoujianChoosing() {
      this.isChoosingShoujian = !this.isChoosingShoujian;
      if (this.shoujianAddress._id) {
        let curr = "shoujian" + this.shoujianAddress._id;
        this.$refs[curr][0].checked = true;
      }
    },
    chooseShoujian(address) {
      this.isChoosingShoujian = !this.isChoosingShoujian;
      this.shoujianAddress = address;
    },
    addMoreAddress(type) {
      this.isAddingAddress = true;
      this.currAddingType = type;
    },
    managerAddress() {
      this.$router.push("/address/" + this.encodeToken);
    },
    cancelAdding() {
      this.isAddingAddress = false;
    },
    clearAutoAddress() {
      this.autoAddress = "";
    },
    regAutoAddress() {
      let that = this;
      if (!this.autoAddress) {
        weui.alert("请输入您的收件信息");
        return;
      } else {
        let result = commonUtil.autoDiscern(this.autoAddress);
        if (result.success) {
          this.addAddress.name = result.data.name;
          this.addAddress.phone = result.data.phone;

          let tempProvName = result.data.provName;
          let tempAddress = result.data.address;
          let tempProv = {};
          let tempCity = {};
          let tempCounty = {};

          for (let i = 0; i < this.provinces.length; i++) {
            let currProvName = this.provinces[i].name;
            let currProvShortName = currProvName.substr(0, 2);
            if (tempAddress.indexOf(currProvName) == 0) {
              tempProv = this.provinces[i];
              tempAddress = tempAddress.replace(
                new RegExp(currProvName, "g"),
                ""
              );
              break;
            } else if (tempAddress.indexOf(currProvShortName) == 0) {
              tempProv = this.provinces[i];
              tempAddress = tempAddress.replace(
                new RegExp(currProvShortName, "g"),
                ""
              );
              break;
            }
          }

          if (tempProv._id) {
            // 根据省份查找市列表
            if (
              tempProv.name.indexOf("北京") == 0 ||
              tempProv.name.indexOf("上海") == 0 ||
              tempProv.name.indexOf("天津") == 0 ||
              tempProv.name.indexOf("重庆") == 0
            ) {
              axios
                .get("/api/city/getByCode/" + tempProv.code)
                .then(res => {
                  if (res.data.success) {
                    tempCity = res.data.data;
                    let currCityName = tempCity.name;
                    let currCityShortName = currCityName.substr(0, 2);
                    if (tempAddress.indexOf(currCityName) == 0) {
                      tempAddress = tempAddress.replace(
                        new RegExp(currCityName, "g"),
                        ""
                      );
                    } else if (tempAddress.indexOf(currCityShortName) == 0) {
                      tempAddress = tempAddress.replace(
                        new RegExp(currCityShortName, "g"),
                        ""
                      );
                    }

                    // 查找并替换区
                    let params = {
                      cityCode: tempCity.code
                    };
                    axios
                      .get("/api/county/list", { params })
                      .then(res => {
                        if (res.data.success) {
                          let tempCounties = res.data.data;
                          for (let k = 0; k < tempCounties.length; k++) {
                            let currCountyName = tempCounties[k].name;
                            let currCountyShortName = currCountyName.substr(
                              0,
                              2
                            );
                            if (tempAddress.indexOf(currCountyName) == 0) {
                              tempCounty = tempCounties[k];
                              tempAddress = tempAddress.replace(
                                new RegExp(currCountyName, "g"),
                                ""
                              );
                              break;
                            } else if (
                              tempAddress.indexOf(currCountyShortName) == 0
                            ) {
                              tempCounty = tempCounties[k];
                              tempAddress = tempAddress.replace(
                                new RegExp(currCountyName, "g"),
                                ""
                              );
                              break;
                            }
                          }

                          this.addAddress.province = tempProv._id;
                          this.addAddress.provinceName = tempProv.name;
                          this.addAddress.city = tempCity._id;
                          this.addAddress.cityName = tempCity.name;
                          this.addAddress.county = tempCounty._id;
                          this.addAddress.countyName = tempCounty.name;
                          this.addAddress.detail = tempAddress;
                        } else {
                          weui.alert("获取" + tempCity.name + "下属区县出错");
                          return;
                        }
                      })
                      .catch(err => {
                        weui.alert("获取" + tempCity.name + "下属区县出错");
                        return;
                      });
                  } else {
                    weui.alert("获取" + tempProv.name + "下属城市出错");
                    return;
                  }
                })
                .catch(err => {
                  weui.alert("获取" + tempProv.name + "下属城市出错");
                  return;
                });
            } else {
              // 加载市数据
              let params = {
                provinceCode: tempProv.code
              };
              axios
                .get("/api/city/list", { params })
                .then(res => {
                  if (res.data.success) {
                    let tempCities = res.data.data;
                    for (let j = 0; j < tempCities.length; j++) {
                      let currCityName = tempCities[j].name;
                      let currCityShortName = currCityName.substr(0, 2);
                      if (tempAddress.indexOf(currCityName) == 0) {
                        tempCity = tempCities[j];
                        tempAddress = tempAddress.replace(
                          new RegExp(currCityName, "g"),
                          ""
                        );
                        break;
                      } else if (tempAddress.indexOf(currCityShortName) == 0) {
                        tempCity = tempCities[j];
                        tempAddress = tempAddress.replace(
                          new RegExp(currCityShortName, "g"),
                          ""
                        );
                        break;
                      }
                    }

                    // 查找并替换区
                    let params = {
                      cityCode: tempCity.code
                    };
                    axios
                      .get("/api/county/list", { params })
                      .then(res => {
                        if (res.data.success) {
                          let tempCounties = res.data.data;
                          for (let k = 0; k < tempCounties.length; k++) {
                            let currCountyName = tempCounties[k].name;
                            let currCountyShortName = currCountyName.substr(
                              0,
                              2
                            );
                            if (tempAddress.indexOf(currCountyName) == 0) {
                              tempCounty = tempCounties[k];
                              tempAddress = tempAddress.replace(
                                new RegExp(currCountyName, "g"),
                                ""
                              );
                              break;
                            } else if (
                              tempAddress.indexOf(currCountyShortName) == 0
                            ) {
                              tempCounty = tempCounties[k];
                              tempAddress = tempAddress.replace(
                                new RegExp(currCountyName, "g"),
                                ""
                              );
                              break;
                            }
                          }

                          this.addAddress.province = tempProv._id;
                          this.addAddress.provinceName = tempProv.name;
                          this.addAddress.city = tempCity._id;
                          this.addAddress.cityName = tempCity.name;
                          this.addAddress.county = tempCounty._id;
                          this.addAddress.countyName = tempCounty.name;
                          this.addAddress.detail = tempAddress;
                        } else {
                          weui.alert("获取" + tempCity.name + "下属区县出错");
                          return;
                        }
                      })
                      .catch(err => {
                        weui.alert("获取" + tempCity.name + "下属区县出错");
                        return;
                      });
                  } else {
                    weui.alert("获取" + tempProv.name + "下属城市出错");
                    return;
                  }
                })
                .catch(err => {
                  weui.alert("获取" + tempProv.name + "下属城市出错");
                  return;
                });
            }
          }
        } else {
          weui.alert(result.message);
          return;
        }
      }
    },
    saveAdding() {
      if (!this.addAddress.name) {
        weui.alert("联系人员不能为空");
        return;
      } else if (!this.addAddress.phone || this.addAddress.phone.length != 11) {
        weui.alert("联系电话为空或格式不正确");
        return;
      } else if (
        !this.addAddress.provinceName ||
        this.addAddress.provName == "请选择" ||
        !this.addAddress.cityName ||
        this.addAddress.cityName == "请选择" ||
        !this.addAddress.countyName ||
        this.addAddress.countyName == "请选择"
      ) {
        weui.alert("请选择完整的省市区");
        return;
      } else if (!this.addAddress.detail) {
        weui.alert("详细地址不能为空");
        return;
      }

      axios
        .post("/api/address/wxadd", this.addAddress)
        .then(res => {
          this.isAddingAddress = false;
          if (res.data.success) {
            if (this.currAddingType == 1) {
              this.isChoosingJijian = false;
              this.jijianAddress = res.data.data;
              this.jijianAddress.province = {
                _id: res.data.data.province,
                name: this.addAddress.provinceName
              };
              this.jijianAddress.city = {
                _id: res.data.data.city,
                name: this.addAddress.cityName
              };
              this.jijianAddress.county = {
                _id: res.data.data.county,
                name: this.addAddress.countyName
              };

              this.addresses.push(this.jijianAddress);
              this.jijianAddress.push(this.jijianAddress);
            } else {
              this.isChoosingShoujian = false;
              this.shoujianAddress = res.data.data;
              this.shoujianAddress.province = {
                _id: res.data.data.province,
                name: this.addAddress.provinceName
              };
              this.shoujianAddress.city = {
                _id: res.data.data.city,
                name: this.addAddress.cityName
              };
              this.shoujianAddress.county = {
                _id: res.data.data.county,
                name: this.addAddress.countyName
              };

              this.addresses.push(this.shoujianAddress);
              this.shoujianAddresses.push(this.shoujianAddress);
            }
            this.addAddress = {
              name: "",
              phone: "",
              province: "",
              city: "",
              county: "",
              provinceName: "",
              cityName: "",
              countyName: "",
              detail: ""
            };
          } else {
            weui.alert("新增收件人信息失败");
            console.log(err);
          }
        })
        .catch(err => {
          weui.alert("新增收件人信息失败");
          console.log(err);
        });
    },
    addTotakein() {
      if (!this.currExpressSendCompany._id) {
        weui.alert("请选择快递公司");
        return;
      } else if (!this.jijianAddress._id) {
        weui.alert("寄件人不能为空，请联系客服");
        return;
      } else if (!this.shoujianAddress._id) {
        weui.alert("请选择收件人");
        return;
      } else if (!this.goodsName) {
        weui.alert("物品名称不能为空");
        return;
      } else if (!this.goodsCount || this.goodsCount < 0) {
        weui.alert("物品数量必须>=1");
        return;
      } else if (this.insureMoney && this.insureMoney <= 0) {
        weui.alert("保价金额必须>0");
        return;
      } else if (this.requiredDoorService) {
        if (!this.goodsType) {
          weui.alert("请选择物品类别");
          return;
        } else if (this.goodsType == 3 && !this.goodsDetail) {
          weui.alert("请选择大件分类");
          return;
        } else if (!this.pickBuildingId) {
          weui.alert("请选择大楼");
          return;
        } else if (!this.pickFloor) {
          weui.alert("请选择楼层");
          return;
        } else if (!this.dormRoom) {
          weui.alert("请填入宿舍号码");
          return;
        } else if (!this.fee) {
          weui.alert("赏金不能为空");
          return;
        }
      }

      let params = {
        worksite: this.worksiteId,
        schoolCode: this.schoolCode,
        expressCompany: this.currExpressSendCompany._id,
        senderProvince: this.jijianAddress.province._id,
        senderCity: this.jijianAddress.city._id,
        senderCounty: this.jijianAddress.county._id,
        senderDetail: this.jijianAddress.detail,
        sender: this.jijianAddress.name,
        senderPhone: this.jijianAddress.phone,
        senderAddress:
          this.jijianAddress.province.name +
          this.jijianAddress.city.name +
          this.jijianAddress.county.name +
          this.jijianAddress.detail,
        receiverProvince: this.shoujianAddress.province._id,
        receiverCity: this.shoujianAddress.city._id,
        receiverCounty: this.shoujianAddress.county._id,
        receiverDetail: this.shoujianAddress.detail,
        receiver: this.shoujianAddress.name,
        receiverPhone: this.shoujianAddress.phone,
        receiverAddress:
          this.shoujianAddress.province.name +
          this.shoujianAddress.city.name +
          this.shoujianAddress.county.name +
          this.shoujianAddress.detail,
        goodsName: this.goodsName,
        goodsCount: this.goodsCount ? this.goodsCount : 1,
        estimateWeight: this.estimateWeight,
        insureMoney: this.insureMoney,
        isDaofu: this.isDaofu,
        requiredDoorService: this.requiredDoorService,
        paotuiRemark: this.paotuiRemark,
        remark: this.remark,
        goodsType: this.goodsType,
        dormBuilding: this.pickBuildingId,
        startPoint:
          this.pickBuildingTxt + this.pickFloor + "楼" + this.dormRoom,
        dormFloor: this.pickFloor,
        dormRoom: this.dormRoom,
        requireArriveTime:
          moment().format("YYYY-MM-DD") +
          " " +
          this.expressPmDoorServiceEnd +
          ":00"
      };
      if (this.requiredDoorService) {
        params.sexLimit = this.sexLimit.value;
        params.fee = this.fee * 100;
        // params.fee = 1;
      }

      axios
        .post("/api/expressTakein", params)
        .then(res => {
          if (res.data.success) {
            if (this.requiredDoorService) {
              let paotuiId = res.data.data._id;
              // 跳转到预约成功待支付页面
              this.$router.push(
                "/orderSuccess/" + paotuiId + "/" + this.encodeToken
              );
            } else {
              // 跳转到寄件记录列表
              this.$router.push("/expressSendList/ing/" + this.encodeToken);
            }
          } else {
            weui.alert("提交失败");
          }
        })
        .catch(err => {
          console.log(err);
          weui.alert("提交失败");
        });
    }
  }
};
</script>
<style scoped>
.mail {
  font-size: 16px;
  margin: 0 auto;
}
.mail .mail-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
}
.nav-item {
  flex: 1;
  font-weight: bold;
  text-align: center;
}
.nav-item i {
  font-size: 20px;
}
.nav-item.select {
  color: #1aad19;
  border-bottom: 3px solid #1aad19;
}
.nav-item.notselect {
  color: grey;
  border-bottom: 3px solid #ccc;
}
.robbing-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  text-align: center;
  font-size: 16px;
}
.robbing-nav-item {
  flex: 1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
}
.robbing-nav-item:last-child {
  border-right: none;
}
.robbing-nav-item.select {
  color: red;
  border-bottom: 1px solid red;
}
.mail-tips {
  text-align: left;
  padding: 10px;
  padding-left: 15px;
  background-color: lightyellow;
}
.weui-cells {
  margin-top: 0px;
}
.mail-toandget {
  margin-left: 15px;
  margin-right: 15px;
}
.mail-toandget p {
  padding: 3px 0px;
}
.mail-item {
  display: flex;
  align-items: center;
  padding: 8px 0px;
}
.mail-item + .mail-item {
  border-top: 1px solid #eee;
}
.mail-item-left {
  width: 50px;
}
.jijian {
  color: #1aad19;
  font-size: 3rem;
}
.shoujian {
  color: red;
  font-size: 3rem;
}
.mail-item-middle {
  flex: 1;
  text-align: left;
}
.mail-item-middle .weui-cell {
  padding-left: 0px;
}
.weui-cell_address {
  font-size: 14px;
}
.mail-item_empty {
  margin-top: 15px;
  margin-bottom: 15px;
}
.addressAddBtn {
  text-align: right;
  margin-right: 15px;
  margin-bottom: 15px;
}
.weui-cells_form.address {
  margin: 10px;
  border: 2px dotted grey;
  border-radius: 5px;
}
.weui-cells_form .weui-cell__ft {
  font-size: 17px;
}
.weui-cells_form .weui-cells:before {
  left: 15px;
}
.weui-cells_form .weui-cells:after {
  border-bottom: none;
}
.mail-item-middle .weui-cells::before {
  border-top: none;
}
.weui-cells_radio .weui-cell::before {
  left: 0px;
}
.addressAddBtn .weui-btn_mini {
  font-size: 14px;
  padding-left: 24px;
  padding-right: 24px;
}
.mail-user {
  font-size: 18px;
  font-weight: bold;
}
.mail-setmsg {
  border-top: 1px solid #eee;
}
.mail-setmsg-item {
  text-align: left;
}
.mail-setmsg-item.top,
.mail-setmsg-item.middle {
  line-height: 40px;
  height: 40px;
  border-bottom: 1px solid #eee;
  padding-left: 5px;
}
.mail-setmsg-item.middle {
  display: flex;
}
.mail-item-middle_jijian .weui-cells::after {
  border-bottom: none;
}
.mail-item-middle_shoujian .weui-cells::after {
  border-bottom: none;
}
.middle-left {
  width: 120px;
}
.middle-right {
  flex: 1;
  text-align: right;
}
.mail-setmsg-item.bottom {
  display: flex;
  min-height: 80px;
  align-items: center;
}
.bottom-remark-left {
  width: 50px;
  line-height: 80px;
  padding-left: 5px;
  border-right: 1px solid #eee;
  text-align: center;
}
.bottom-remark-right {
  padding-left: 0px;
  flex: 1;
  padding: 5px 0px;
}
.bottom-remark-right textarea {
  display: block;
  width: 100%;
  height: 80px;
  border: 0px;
}
.mail-submit {
  display: block;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  color: white;
  background-color: #1aad19;
  bottom: 0px;
  left: 0px;
  width: 100%;
}
.mail-go-item {
  border: 1px solid #eee;
  margin-top: 10px;
}
.mail-item-top {
  display: flex;
  border-bottom: 1px solid #eee;
  padding: 10px 5px;
}
.mail-item-top-left {
  width: 100px;
}
.mail-item-top-right {
  text-align: left;
}
.weui-picker__content .weui-picker__item {
  font-size: 18px;
}
a.doorservice::before {
  border-top: 1px solid #e5e5e5;
}
.add-address {
  border: #1aad19 1px solid;
  border-radius: 5px;
  padding: 3px 6px;
  color: #1aad19;
}
.edit-address {
  border: orangered 1px solid;
  border-radius: 5px;
  padding: 3px 6px;
  margin-left: 10px;
  color: orangered;
}
.to-choose-item {
  border: 2px dotted grey;
  border-radius: 5px;
  margin-top: 10px;
}
.to-choose-item .weui-cell__bd {
  padding: 0px 0px 0px 10px;
}
.remark-error {
  color: red;
}
.empty-data {
  text-align: center;
  margin-top: 30px;
}
.empty-data div i {
  font-size: 120px;
  color: #cccccc;
}
.warehousing-footer-item {
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
  color: #ffffff;
}
.warehousing-footer-item a {
  color: #ffffff;
}
.shangjin {
  background-color: orangered;
}
.address-error {
  color: red;
}
</style>
<style>
.weui-picker__item {
  font-size: 18px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ExpressTotakein.vue